// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"2ae5dbe8","732":"267e50bf","977":"07f8ca14"}[chunkId] + ".chunk.js";
};